

import {
    UserSummaryFieldModule
} from '../../../../../account/modules/user/api/component/user-summary-field/user-summary-field.module';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SummaryModule } from '../../../../../core/component/summary/summary.module';
import { SummaryFieldModule } from '../../../../../core/component/summary-field/summary-field.module';
import {
    DatetimeSummaryFieldModule
} from '../../../../../core/component/date/datetime-summary-field/datetime-summary-field.module';
import { DatetimeLabelModule } from '../../../../../core/component/date/datetime-label/datetime-label.module';
import { NgModule } from '@angular/core';
import { WorkflowTaskStatusLabelComponent } from './workflow-task-status-label.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        DatetimeSummaryFieldModule,
        DatetimeLabelModule,
        SummaryFieldModule,
    ],
    declarations: [
        WorkflowTaskStatusLabelComponent,
    ],
    exports: [
        WorkflowTaskStatusLabelComponent
    ],
})
export class WorkflowTaskStatusLabelModule {
}
